export default __webpack_public_path__ + "static/media/fake2.3b30ea12.jpg";